import { defineMessages } from 'react-intl';


const GIC_TERMS = [ 1, 3, 4, 6, 12, 24, 36, 48, 60, 120 ];

const MESSAGES = defineMessages({
    'filterTerm-1': {
        id: 'web-components.gics.filter-term-1',
        defaultMessage: '30 days',
    },
    'filterTerm-3': {
        id: 'web-components.gics.filter-term-3',
        defaultMessage: '90 days',
    },
    'filterTerm-4': {
        id: 'web-components.gics.filter-term-4',
        defaultMessage: '120 days',
    },
    'filterTerm-6': {
        id: 'web-components.gics.filter-term-6',
        defaultMessage: '6 months',
    },
    'filterTerm-12': {
        id: 'web-components.gics.filter-term-12',
        defaultMessage: '1 year',
    },
    'filterTerm-24': {
        id: 'web-components.gics.filter-term-24',
        defaultMessage: '2 years',
    },
    'filterTerm-36': {
        id: 'web-components.gics.filter-term-36',
        defaultMessage: '3 years',
    },
    'filterTerm-48': {
        id: 'web-components.gics.filter-term-48',
        defaultMessage: '4 years',
    },
    'filterTerm-60': {
        id: 'web-components.gics.filter-term-60',
        defaultMessage: '5 years',
    },
    'filterTerm-120': {
        id: 'web-components.gics.filter-term-120',
        defaultMessage: '10 years',
    },
});

const GIC_TERMS_OPTIONS = GIC_TERMS.map(value => ({
    value: value,
    label: MESSAGES[`filterTerm-${value}`],
}));


export { GIC_TERMS };
export default GIC_TERMS_OPTIONS;
